import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from "aws-amplify";
import amplifyconfig from './amplifyconfiguration.json';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './msalConfig';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './theme';
import { logger } from './logger';
import { startHealthMonitor } from './services/healthMonitor'; // added

// Configure AWS Amplify
Amplify.configure(amplifyconfig);

// Start in-memory health monitor (collects heartbeat log lines)
startHealthMonitor(); // added

const DISABLE_MSAL = process.env.REACT_APP_DISABLE_MSAL === 'true'; // added

const rootEl = document.getElementById('root');
const root = ReactDOM.createRoot(rootEl);

if (DISABLE_MSAL) {
  logger.info('MSAL disabled – starting app without auth provider');
  console.warn('[index] MSAL disabled via REACT_APP_DISABLE_MSAL flag – rendering App without auth.');
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
} else {
  const msalInstance = new PublicClientApplication(msalConfig);

  // Defer all MSAL API usage and rendering until initialized
  msalInstance.initialize()
    .then(() => {
      // Safe to use MSAL APIs now
      msalInstance.handleRedirectPromise()
        .then((response) => {
          if (response) {
            console.log('Redirect response:', response);
          }
        })
        .catch((error) => {
          console.error('Redirect error:', error);
        });

      msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS) {
          console.log('Login successful:', event);
        }
        if (event.eventType === EventType.LOGIN_FAILURE) {
          console.error('Login failed:', event);
        }
        if (event.eventType === EventType.LOGOUT_SUCCESS) {
          console.log('Logout successful:', event);
        }
      });

      logger.info('MSAL initialized');
      root.render(
        <React.StrictMode>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <MsalProvider instance={msalInstance}>
              <App />
            </MsalProvider>
          </ThemeProvider>
        </React.StrictMode>
      );
    })
    .catch((e) => {
      logger.error('MSAL init error:', e);
      console.error('MSAL init error:', e);
      root.render(
        <React.StrictMode>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </React.StrictMode>
      );
    });
}

reportWebVitals();
